import { useState } from "react"

/**
 * 서비스 일시정지 모달 — 선택적 정지 사유를 입력받아 `suspendService` 호출.
 */
export function SuspendModal(props: {
	readonly slug: string
	readonly onClose: () => void
	readonly onConfirm: (reason?: string) => Promise<void>
}) {
	const [reason, setReason] = useState("")
	const [busy, setBusy] = useState(false)
	const [error, setError] = useState<string | undefined>()

	async function submit(e: React.FormEvent) {
		e.preventDefault()
		setBusy(true)
		setError(undefined)
		try {
			await props.onConfirm(reason.trim() ? reason.trim() : undefined)
			props.onClose()
		} catch (err) {
			setError((err as Error).message)
		} finally {
			setBusy(false)
		}
	}

	return (
		<dialog
			className="modal-backdrop"
			open
			onMouseDown={(e) => e.currentTarget === e.target && props.onClose()}
		>
			<form className="modal" onMouseDown={(e) => e.stopPropagation()} onSubmit={submit}>
				<div className="modal-head">
					<h2>서비스 일시정지</h2>
					<p>
						<code className="inline">{props.slug}</code> 의 MCP 엔드포인트가 403 을 반환하게 됩니다.
					</p>
				</div>

				<div className="modal-body">
					{error && (
						<div className="alert alert-danger" style={{ marginBottom: 14 }}>
							{error}
						</div>
					)}
					<div className="field">
						<label className="field-label" htmlFor="reason">
							정지 사유 (선택)
						</label>
						<textarea
							id="reason"
							className="input"
							placeholder="예: 정책 위반, 사용자 요청 등"
							value={reason}
							onChange={(e) => setReason(e.target.value)}
							maxLength={500}
							style={{ minHeight: 100 }}
						/>
						<span className="field-hint">최대 500자. 감사 로그 diff 에 기록됩니다.</span>
					</div>
				</div>

				<div className="modal-foot">
					<button type="button" className="btn btn-ghost" onClick={props.onClose} disabled={busy}>
						취소
					</button>
					<button type="submit" className="btn btn-danger" disabled={busy}>
						{busy ? "처리 중..." : "일시정지"}
					</button>
				</div>
			</form>
		</dialog>
	)
}
